// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Moment = require("moment");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var TicketPark$ReactHooksTemplate = require("./ticketPark.res.js");
var TicketClose$ReactHooksTemplate = require("./ticketClose.res.js");
var TicketAssign$ReactHooksTemplate = require("./ticketAssign.res.js");
var TicketReopen$ReactHooksTemplate = require("./ticketReopen.res.js");
var TicketComment$ReactHooksTemplate = require("./ticketComment.res.js");
var TicketResolve$ReactHooksTemplate = require("./ticketResolve.res.js");

function id(t) {
  return t.id;
}

function categoryType(t) {
  return t.categoryType;
}

function createdAt(t) {
  return t.createdAt;
}

function activityDetails(t) {
  return t.activityDetails;
}

function decode(json) {
  var activityType = Json_decode.field("activity", Json_decode.string, json);
  if (activityType === TicketClose$ReactHooksTemplate.activityType) {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketClose",
              _0: TicketClose$ReactHooksTemplate.fromJson(json)
            }
          };
  } else if (activityType === TicketPark$ReactHooksTemplate.activityType) {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketPark",
              _0: TicketPark$ReactHooksTemplate.fromJson(json)
            }
          };
  } else if (activityType === TicketAssign$ReactHooksTemplate.activityType) {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketAssign",
              _0: TicketAssign$ReactHooksTemplate.fromJson(json)
            }
          };
  } else if (activityType === TicketClose$ReactHooksTemplate.activityType) {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketClose",
              _0: TicketClose$ReactHooksTemplate.fromJson(json)
            }
          };
  } else if (activityType === TicketResolve$ReactHooksTemplate.activityType) {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketResolve",
              _0: TicketResolve$ReactHooksTemplate.fromJson(json)
            }
          };
  } else if (activityType === TicketReopen$ReactHooksTemplate.activityType) {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketReopen",
              _0: TicketReopen$ReactHooksTemplate.fromJson(json)
            }
          };
  } else {
    return {
            id: Json_decode.field("id", Json_decode.$$int, json),
            categoryType: activityType,
            ticketId: Json_decode.field("ticket_id", Json_decode.$$int, json),
            createdAt: Moment(new Date(Json_decode.field("created_at", Json_decode.string, json))),
            activityDetails: {
              TAG: "TicketComment",
              _0: TicketComment$ReactHooksTemplate.fromJson(json)
            }
          };
  }
}

exports.id = id;
exports.categoryType = categoryType;
exports.createdAt = createdAt;
exports.activityDetails = activityDetails;
exports.decode = decode;
/* moment Not a pure module */
